import {Button} from 'antd'
import ContextMenu from '@/components/ContextMenu/ContextMenu.jsx'
import {PopoverTrigger} from '@/components/Popover/index.mjs'
import {MapContext, useMapContext} from '@/components/MindMap/index.mjs'

const normalizeItems = items => {
    const _items = []

    for (const item of items) {
        if (! item) {
            ;
        }
        else if (item.divider) {
            const lastItem = _items.at(- 1)

            if (lastItem && ! lastItem.divider) {
                _items.push(item)
            }
        }
        else if (item.children) {
            const children = normalizeItems(item.children)

            if (0 < children.length) {
                _items.push({...item, children})
            }
        }
        else {
            _items.push(item)
        }
    }

    if (_items.at(- 1)?.divider) {
        _items.pop()
    }

    return _items
}

export default function MenuButton({children, items, ...props}) {
    const map = useMapContext()

    if (! items) {
        return (
            <Button {...props}>
                {children}
            </Button>
        )
    }

    const _items = normalizeItems(items)

    if (0 === _items.length) {
        return null
    }

    const content = (
        <MapContext.Provider value={map}>
            <ContextMenu items={_items} />
        </MapContext.Provider>
    )

    return (
        <PopoverTrigger
            align="left"
            content={content}
            position="bottom"
            {...props}
        >
            <Button>{children}</Button>
        </PopoverTrigger>
    )
}
